var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('van-overlay',{attrs:{"show":_vm.loading},on:{"click":function($event){_vm.loading = false}}},[_c('div',{staticClass:"wrapper",on:{"click":function($event){$event.stopPropagation();}}},[_c('van-loading',{attrs:{"type":"spinner","color":"#ffffff"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }